import styled from "@emotion/styled";
import { LdIcon, LdTypo } from "@liquid/react";

import { pxToRem } from "@src/utils";

import { Card } from "../Card";

export const StyledErrorCard = styled(Card)`
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - var(--horizontal-paddings) - var(--horizontal-paddings));
`;

export const StyledErrorCardContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(20)};
  padding: ${pxToRem(25)} 0;
`;
export const StyledIcon = styled(LdIcon)`
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  border-radius: ${pxToRem(15)};
  background-color: var(--ld-col-rr-600);

  svg {
    color: var(--ld-col-wht);
  }
`;

export const StyledErrorCardHeader = styled(LdTypo)`
  margin-bottom: ${pxToRem(20)};
`;
